import React, { useEffect, useState } from "react";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import { Nav, Tab } from "react-bootstrap";
import "./Selection_method.css";
import Repeatability from "./repeatability/Repeatability";
import Reproducibility from "./reproducibility/Reproducibility";
import Accuracy from "./accuracy/Accuracy";
import {
  Create,
  GetAll,
} from "../../../../../../../src/features/admin/quality_management/process_requirement/repeatability/Slice";
import { useDispatch, useSelector } from "react-redux";

const Selection_method = () => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [activeSelectionTypeId, setActiveSelectionTypeId] = useState(1);
  const repeatabilitydetails = useSelector((state) => state.repeatability.data);

  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        page,
        per_page: 10,
        selection_type_id: activeSelectionTypeId,
      }),
    );
  };

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [activeSelectionTypeId, currentPage]);

 
  return (
    <section className="Sample_Report">
      <div className="back_div">
        <Common_Back_Btn backText="Selection, Verification & Validation Of Method" />
      </div>

      <div className="tables_tab_section">
        {/* <Tab.Container id="left-tabs-example" defaultActiveKey="Repeatability"> */}
        <Tab.Container
          defaultActiveKey="Repeatability"
          onSelect={(key) => {
            let id = 1;
            if (key === "Repeatability") id = 1;
            if (key === "Reproducibility") id = 2;
            if (key === "Accuracy") id = 3;
            console.log(id, "idid");

            setActiveSelectionTypeId(id);
            fetchCustomers(1, id);
          }}
        >
          <Nav variant="pills" className="">
            <Nav.Item>
              <Nav.Link eventKey="Repeatability">Repeatability</Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link eventKey="Reproducibility">Reproducibility</Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link eventKey="Accuracy">Accuracy</Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content className="inner-tab-sec">
            <Tab.Pane eventKey="Repeatability">
              <Repeatability
              fetchCustomers={fetchCustomers}
                repeatabilitydetails={repeatabilitydetails}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
                // selectionTypeId={activeSelectionTypeId}
              />
            </Tab.Pane>

            <Tab.Pane eventKey="Reproducibility">
              {/* selectionTypeId={activeSelectionTypeId} */}
              <Reproducibility
                fetchCustomers={fetchCustomers}
                repeatabilitydetails={repeatabilitydetails}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
              />
            </Tab.Pane>

            <Tab.Pane eventKey="Accuracy">
              <Accuracy />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </section>
  );
};

export default Selection_method;
